var _ellipse, _ellipse2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestartMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34,
    cy: 34.1779,
    rx: 34,
    ry: 33.4237,
    fill: "#F8A4AE"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.6139,
    cy: 34.8696,
    rx: 29.6002,
    ry: 29.0985,
    fill: "#FF4C61"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3112_25110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0483 23.2952C26.7035 20.9944 30.1005 19.7301 33.6138 19.735C41.6956 19.735 48.2467 26.2861 48.2467 34.3679C48.2467 37.4935 47.2663 40.3908 45.5982 42.7671L40.9303 34.3679H45.3201C45.3203 32.0729 44.6459 29.8285 43.3808 27.9137C42.1157 25.9989 40.3156 24.4982 38.2044 23.5983C36.0933 22.6983 33.7641 22.4387 31.5066 22.8518C29.2491 23.2649 27.1629 24.3325 25.5072 25.9218L24.0483 23.2952ZM43.1793 45.4406C40.5241 47.7414 37.1272 49.0056 33.6138 49.0007C25.5321 49.0007 18.981 42.4496 18.981 34.3679C18.981 31.2423 19.9614 28.345 21.6295 25.9686L26.2974 34.3679H21.9075C21.9073 36.6629 22.5817 38.9073 23.8469 40.8221C25.112 42.7368 26.9121 44.2375 29.0232 45.1375C31.1344 46.0375 33.4635 46.297 35.721 45.8839C37.9785 45.4708 40.0648 44.4032 41.7204 42.814L43.1793 45.4406Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3112_25110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.1189,
    height: 35.1189,
    fill: "white",
    transform: "translate(16.0544 16.8085)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestartMenu);
export default __webpack_public_path__ + "static/media/restart-menu.71a3b9e78a6bec1b56bfb591e7c96d24.svg";
export { ForwardRef as ReactComponent };